import React, { useRef, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * Composant d'accessibilité
 * Annonce le changement de page aux technologies d'assistance (lecteurs d'écran)
 * en positionnant le focus sur un paragraphe en masquage accessible contenant le titre de page.
 */
const RouteAnnouncer = ({ location }) => {
    const [title, setTitle] = useState('');
    const ref = useRef(null);

    useEffect(() => {
        // Délai pour laisser react-helmet mettre à jour document.title
        const timeout = setTimeout(() => {
            setTitle(document.title);
            if (ref.current) {
                ref.current.focus();
            }
        }, 100);

        return () => clearTimeout(timeout);
    }, [location]);

    return (
        <p ref={ref} tabIndex="-1" className="sr-only" role="status">
            {title}
        </p>
    );
};

export default withRouter(RouteAnnouncer);



// WEBPACK FOOTER //
// ./src/components/rgaa/RouteAnnouncer.js